$(function () {
	//bugfix
	$('.b-accordion__item').removeClass('is-opened');
	//main function
	$(document).on('click', '.b-accordion__item-title', function (e) {
		var $parentItem = $(this).closest('.b-accordion__item'),
			windowHeight = window.innerHeight,
			parrentTop,
			parentHeight,
			scrollTarget;
		$parentItem.toggleClass('is-opened');
		$parentItem.siblings().removeClass('is-opened');
		parrentTop = $parentItem.offset().top;
		parentHeight = $parentItem.height();



		function returnScrollToUser() {
			$([document.documentElement, document.body]).stop();
		}

		$([document.documentElement, document.body]).animate({
				scrollTop: parentHeight > windowHeight ? parrentTop : parrentTop - ((windowHeight - parentHeight) / 2)
			},
			1000,
			function () {
				$([document.documentElement, document.body]).off("mousedown wheel DOMMouseScroll mousewheel keyup touchmove", returnScrollToUser);
			});
		$([document.documentElement, document.body]).one("mousedown wheel DOMMouseScroll mousewheel keyup touchmove", returnScrollToUser);
	});
});
